export const CHANGE_INVESTOR_TYPE_DATA = 'CHANGE_INVESTOR_TYPE_DATA';
export type CHANGE_INVESTOR_TYPE_DATA = typeof CHANGE_INVESTOR_TYPE_DATA;


// WEBPACK FOOTER //
// ./src/actions/investor-type/change-data/Types.tsx